import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import React from "react";

import { getUserProfilePath } from "@/helpers/common/path";

interface CommentNameProps {
  displayName: string;
  accountName: string;
}
export const CommentName: React.FC<CommentNameProps> = (props) => {
  const { displayName, accountName } = props;
  const { t } = useTranslation("common");
  const router = useRouter();
  const onClick = () => {
    if (!accountName) return;
    router.push(getUserProfilePath(accountName));
  };
  return (
    <span
      className="touchable text-gray-900 text-base font-bold truncate"
      onClick={onClick}
    >
      {displayName ?? t("common:anonymous")}
    </span>
  );
};
